import * as React from 'react';
import { useSensitivityIcon_unstable } from './useSensitivityIcon';
import { renderSensitivityIcon_unstable } from './renderSensitivityIcon';
import { useSensitivityIconStyles_unstable } from './useSensitivityIconStyles';
import type { SensitivityIconProps } from './SensitivityIcon.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// SensitivityIcon component - TODO: add more docs
export const SensitivityIcon: ForwardRefComponent<SensitivityIconProps> = React.forwardRef((props, ref) => {
  const state = useSensitivityIcon_unstable(props, ref);

  useSensitivityIconStyles_unstable(state);
  return renderSensitivityIcon_unstable(state);
});

SensitivityIcon.displayName = 'SensitivityIcon';
